/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import BoltIcon from '@mui/icons-material/Bolt';
import Tooltip from '@mui/material/Tooltip';
import { withoutBoostFieldName } from 'relevant-shared/booster/utils';
import Checkbox from '../Checkbox';
import PopupSelector from '../PopupSelector';
import BoosterStatus from '../BoosterStatus';

const getPath = ({ field }) => _.initial(field('').name.split('.'))
	.filter((s, i) => s && !(i % 2))
	.map(withoutBoostFieldName)
	.join('.');

function BoosterStatusPopup(props) {
	const { renderContext } = props;
	const [openTooltip, setOpenTooltip] = useState(false);
	const [dialogOpen, setDialogOpen] = useState(false);
	const path = getPath(props);
	return (
		<Tooltip
			title="See current progress of optimization"
			open={openTooltip}
			onOpen={() => !dialogOpen && setOpenTooltip(true)}
			onClose={() => setOpenTooltip(false)}
		>
			<div>
				<PopupSelector
					title="Check status"
					autoExpandKey={path}
					size="lg"
					onExpandChange2={(open) => setDialogOpen(open)}
					fn={() => {
						setDialogOpen(true);
						setOpenTooltip(false);
					}}
					content={() => (
						<BoosterStatus
							paramFilter={{
								scopeId: renderContext.obj.id,
								path,
							}}
						/>
					)}
				/>
			</div>
		</Tooltip>
	);
}

BoosterStatusPopup.propTypes = {
	renderContext: PropTypes.object.isRequired,
};

const BoosterType = {
	inlineRender: true,
	defaultValue: false,
	style: {
		width: 'auto',
	},
	containerStyle: {
		transform: 'scale(0.7)',
		height: 28,
		marginTop: -10,
		marginLeft: 8,
		transformOrigin: 'left top',
		fontStyle: 'italic',
	},
	render: () => {
	},
	renderAfterDataInner: (p) => p.value.value && <BoosterStatusPopup {...p} />,
	renderData: (p) => (
		<>
			<Checkbox
				disabled={p.inDisabled}
				label="Optimize"
				style={{ marginLeft: 2 }}
				{...p.value.props}
				{...(p.field('value'))}
			/>
			<BoltIcon style={{ marginTop: 8, marginLeft: -16, color: 'red' }} />
		</>
	),
	renderSummary: () => {},
};

export default BoosterType;
